import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";

import { SearchSchema } from "../index";

import { ProfileDetailPage } from "@/features/Profiles/ProfileDetailPage";

const ProfileDetailSearchSchema = z.object({
  profilesListingSearch: SearchSchema.optional(),
});

export type ProfileDetailSearch = z.infer<typeof ProfileDetailSearchSchema>;

export const Route = createFileRoute(
  "/_auth/people/$siteId/profiles/$profileId/",
)({
  validateSearch: (raw): ProfileDetailSearch =>
    ProfileDetailSearchSchema.parse(raw),
  component: ProfileDetailPage,
});
